import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

var firebaseConfig = {
  apiKey: 'AIzaSyDMyzmlHAwuKkE75Lobw7Mapa36VY-7JLk',
  authDomain: 'homework2-96731.firebaseapp.com',
  databaseURL: 'https://homework2-96731.firebaseio.com',
  projectId: 'homework2-96731',
  storageBucket: 'homework2-96731.appspot.com',
  messagingSenderId: '1031716202794',
  appId: '1:1031716202794:web:961e3e6692c89ff6ef5653',
};

firebase.initializeApp(firebaseConfig);
export default firebase;
